import { SimpleTable } from '@core/components/Table';
import { useApiUtils } from '@core/util/apiUtils';
import * as Actions from 'app/store/actions';
import moment from 'moment';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { GestaoEnvioContext } from '../../GestaoEnvioContext';
import { GestaoEnvioModais } from '../modal/GestaoEnvioModais';

const GestaoEnvioTable = ({ fetchGestoesEnvio, fetchGestaoEnvio }) => {
  const [gestoesEnvio] = useContext(GestaoEnvioContext).gestoesEnvio;
  const [selecao, setSelecao] = useContext(GestaoEnvioContext).selecao;
  const [loading] = useContext(GestaoEnvioContext).loading;
  const [totalElements] = useContext(GestaoEnvioContext).totalElements;
  const [search] = useContext(GestaoEnvioContext).search;
  const [tipoSelecao, setTipoSelecao] = useContext(GestaoEnvioContext).tipoSelecao;
  const [, setPage] = useContext(GestaoEnvioContext).page;
  const [, setSize] = useContext(GestaoEnvioContext).size;
  const [, setModal] = useContext(GestaoEnvioContext).modal;
  const [filtroAvancado] = useContext(GestaoEnvioContext).filtroAvancado;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const formatSituacaoEnvio = (situacaoEnvio) => {
    switch (situacaoEnvio) {
      case 'ENVIADO':
        return 'Enviado';
      case 'ERRO':
        return 'Erro';
      case 'VISUALIZADO':
        return 'Visualizado';
      default:
        return '-';
    }
  };

  const formatTipoEnvio = (tipoEnvio) => {
    switch (tipoEnvio) {
      case 'CONTAS_RECEBER':
        return 'Cobrança';
      case 'ORDEM_SERVICO':
        return 'Ordem de serviço';
      case 'VENDA':
        return 'Orçamento';
      case 'REGUA_COBRANCA_PASSO':
        return 'Régua de cobrança';
      case 'FATURAMENTO_CONTRATO':
      case 'FATURAMENTO_VENDA':
        return 'Nota fiscal';
      case 'CERTIDAO_NEGATIVA':
        return 'Certidão negativa';
      default:
        return '-';
    }
  };

  const handleOpenModalVisualizar = async (gestaoEnvio) => {
    try {
      await fetchGestaoEnvio(gestaoEnvio.id);
      setModal(GestaoEnvioModais.visualizarGestaoEnvio);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
  };

  const gestaoEnvioColumns = [
    {
      name: 'cliente.pessoa.nome',
      title: 'Cliente',
      sortingEnabled: true,
      align: 'left',
      getCellValue: (gestaoEnvio) => {
        return gestaoEnvio?.cliente?.pessoa?.nome;
      },
    },
    {
      name: 'destinatario',
      title: 'Destinatário',
      sortingEnabled: true,
      align: 'left',
      width: 230,
      getCellValue: (gestaoEnvio) => {
        return gestaoEnvio?.destinatario;
      },
    },
    {
      name: 'assunto',
      title: 'Assunto',
      sortingEnabled: true,
      align: 'left',
      getCellValue: (gestaoEnvio) => {
        return gestaoEnvio?.assunto;
      },
    },
    {
      name: 'dataHoraEnvio',
      title: 'Data / Hora de envio',
      sortingEnabled: true,
      align: 'center',
      getCellValue: (gestaoEnvio) => {
        return gestaoEnvio.dataHoraEnvio ? moment(gestaoEnvio.dataHoraEnvio).format('DD/MM/YYYY - HH:mm') : '';
      },
    },
    {
      name: 'situacaoEnvio',
      title: 'Situação',
      sortingEnabled: true,
      align: 'left',
      getCellValue: (gestaoEnvio) => {
        return formatSituacaoEnvio(gestaoEnvio?.situacaoEnvio);
      },
    },
    {
      name: 'origemEnvio',
      title: 'Tipo de envio',
      sortingEnabled: true,
      align: 'left',
      getCellValue: (gestaoEnvio) => {
        return formatTipoEnvio(gestaoEnvio?.origemEnvio);
      },
    },
  ];

  return (
    <SimpleTable
      getRowId={(row) => row}
      columns={gestaoEnvioColumns}
      rows={gestoesEnvio}
      fetchData={fetchGestoesEnvio}
      onRowClick={handleOpenModalVisualizar}
      loading={loading}
      defaultSorting={[{ columnName: 'dataHoraEnvio', direction: 'desc' }]}
      totalCount={totalElements}
      onCurrentPageChange={(params) => {
        setPage(params);
      }}
      onPageSizeChange={(params) => {
        setSize(params);
      }}
      selectionType={tipoSelecao}
      onSelectionTypeChange={(params) => {
        setTipoSelecao(params);
      }}
      selection={selecao}
      onSelectionChange={(params) => {
        setSelecao(params);
      }}
      onSortingChange={(params) => console.log(params)}
      onLoadingChange={(params) => console.log('loading change', params)}
      searchBy={search}
      params={filtroAvancado}
      contemFiltroAvancado
    />
  );
};
export default GestaoEnvioTable;
